import React from 'react';
import SpeechToSpeechForm from '../components/SpeechToSpeechForm';

const Voice2Voice = () => {
    return <SpeechToSpeechForm />;
}

export default Voice2Voice;